<template>
  <b-row v-if="list.length > 0">
    <b-col>
      <b-list-group class="mt-2 mr-3 ml-3">
        <b-list-group-item
          v-for="item in list"
          v-if="item.value"
          v-bind:key="item.id"
          :id="item.id"
          class="d-flex justify-content-between align-items-center pointer-cursor"
          @click="$emit('item-clicked', item)"
        >
          <span>
            {{ item.text }}
          </span>
          <b-badge variant="dark" pill class="ml-2">$ {{ resolveCurrency(item.value) }}</b-badge>
        </b-list-group-item>
      </b-list-group>
      <div class="text-right mt-3 mr-3 ml-3">
        <span>Total: $ {{total}}</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import helper from '@/libs/helper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

library.add([faTimesCircle]);

export default {
  props: {
    list: Array,
  },
  data() {
    return {
      displayDelete: false,
    };
  },
  computed: {
    total() {
      const values = [];
      this.list.forEach((el) => {
        values.push(el.value);
      });

      return helper.currencySum(values);
    },
  },
  methods: {
    resolveCurrency(value) {
      return helper.currency(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/financial/ListSummary.vue